import { Injectable } from '@angular/core';
import { FileDto, StorageService } from '@api-client';

/**
 * 공용 파일 업로드 서비스
 * 클라이언트의 environment 사용하지 못하여 직접 baseUrl와 container 명을 받아와야합니다.
 */

@Injectable({ providedIn: 'root' })
export class UploadService {
  async upload(
    files: File[],
    baseUrl: string,
    cotainer: string,
  ): Promise<FileDto[]> {
    try {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append('files', file); // `file`은 File 객체
      });

      const res = await fetch(`${baseUrl}/api/storage/${cotainer}`, {
        body: formData,
        method: 'POST',
        headers: {},
      });

      return res.json();
    } catch (error) {
      console.error(error);
      throw new Error('Failed to upload file');
    }
  }

  async delete(url: string, baseUrl: string): Promise<void> {
    const encodedUrl = encodeURIComponent(url);
    await fetch(`${baseUrl}/api/storage/${encodedUrl}`, {
      method: 'DELETE',
    });
    return;
  }

  async deleteMany(urls: string[], baseUrl: string): Promise<void> {
    const body = JSON.stringify({ urls: urls });
    await fetch(`${baseUrl}/api/storage`, {
      method: 'DELETE',
      body,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return;
  }
}
